import { SupabaseClient } from '@supabase/supabase-js';

import { CameraConfig, convertToSimplifiedConfig, Database, withLogs } from '@core';

export const getCameraConfig = withLogs(async (supabase: SupabaseClient<Database>, activityId: number) => {
    const { data, error } = await supabase
        .from('activities')
        .select(
            `camera_calibrations(
                *, 
                setups:camera_calibration_setups!camera_calibration_setups_camera_calibration_id_fkey(
                    *,
                    camera_setups(
                        *,
                        camera_types(*)
                    )
                )
            )
            `,
        )
        .eq('id', activityId)
        .order('id', { ascending: false })
        .limit(1)
        .single();

    if (error) {
        throw error;
    }

    return convertToSimplifiedConfig(
        data.camera_calibrations!.calibration as unknown as CameraConfig,
        data.camera_calibrations?.setups,
    );
}, 'getCameraConfig');
